import React, { useEffect } from "react";
import "./css/Gallery.css";

// Sample images (आप अपने images के path यहाँ डाल सकते हैं)
const images = [
  "https://via.placeholder.com/300x200?text=Image+1",
  "https://via.placeholder.com/300x200?text=Image+2",
  "https://via.placeholder.com/300x200?text=Image+3",
  "https://via.placeholder.com/300x200?text=Image+4",
  "https://via.placeholder.com/300x200?text=Image+5",
  "https://via.placeholder.com/300x200?text=Image+6",
];

export default function Gallery() {
  useEffect(() => {
    document.title = "Gallery | My MLM Website";
  }, []);
  return (
    <div className="gallery-container">
      <h1 className="gallery-heading">Our Gallery</h1>
      <p className="gallery-description">
        यहाँ हमारी कंपनी और MLM events की कुछ images हैं। हम professional और
        verified business events में actively participate करते हैं।
      </p>

      <div className="gallery-grid">
        {images.map((img, index) => (
          <div key={index} className="gallery-item">
            <img src={img} alt={`Gallery ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
